import { render, staticRenderFns } from "./AppCompoundRating.vue?vue&type=template&id=298ad7ac&scoped=true"
import script from "./AppCompoundRating.vue?vue&type=script&lang=ts"
export * from "./AppCompoundRating.vue?vue&type=script&lang=ts"
import style0 from "./AppCompoundRating.vue?vue&type=style&index=0&id=298ad7ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298ad7ac",
  null
  
)

export default component.exports